import React, { useEffect } from "react";
import ShellCard from "../../components/ShellCard";
import heroBanner from "../../assets/images/pages/dui-school-details.jpg";

const BureauAdministrativeReview = () => {
    useEffect(() => {
        document.title = "Bureau of Administrative Review Office - Metro Traffic School";
    }, []);

    const locations = [
        {
            county: "Dade",
            city: "Miami",
            address: "7795 W. Flagler St., Ste. 82C",
            zip: "33144",
            phone: "(305) 229-6333",
        },
        {
            county: "Broward",
            city: "Lauderdale Lakes",
            address: "3718-3 W. Oakland Park Blvd.",
            zip: "33311",
            phone: "(954) 677-5801",
        },
        {
            county: "Palm Beach",
            city: "Lantana",
            address: "1299 W. Lantana Rd.",
            zip: "33462",
            phone: "(561) 681-6333",
        },
    ];

    return (
        <>
            <section className="hero-slider-section">
                <div
                    className="hero-banner"
                    style={{
                        backgroundImage: `url(${heroBanner})`,
                        backgroundPosition: "center",
                        backgroundSize: "cover",
                    }}
                >
                    <div className="banner-text-container">
                        <div className="banner-heading">
                            <h1 className="banner-title">Bureau Of Administrative Review Office</h1>
                        </div>
                    </div>
                </div>
            </section>

            <div className="container py-5">
                <ShellCard>
                    <div className="table-responsive">
                        <table className="table table-hover mb-0 text-white" style={{ backgroundColor: "transparent" }}>
                            <thead>
                                <tr>
                                    <th className="text-warning text-uppercase" style={{ backgroundColor: "transparent", borderColor: "#444" }}>County</th>
                                    <th className="text-warning" style={{ backgroundColor: "transparent", borderColor: "#444" }}>City</th>
                                    <th className="text-warning" style={{ backgroundColor: "transparent", borderColor: "#444" }}>Address</th>
                                    <th className="text-warning" style={{ backgroundColor: "transparent", borderColor: "#444" }}>Zip Code</th>
                                    <th className="text-warning" style={{ backgroundColor: "transparent", borderColor: "#444" }}>Phone Number</th>
                                </tr>
                            </thead>
                            <tbody>
                                {locations.map((loc, index) => (
                                    <tr key={index}>
                                        <td className="text-uppercase" style={{ backgroundColor: "transparent", borderColor: "#444", color: "white" }}>{loc.county}</td>
                                        <td className="text-capitalize" style={{ backgroundColor: "transparent", borderColor: "#444", color: "white" }}>{loc.city}</td>
                                        <td style={{ backgroundColor: "transparent", borderColor: "#444", color: "white" }}>{loc.address}</td>
                                        <td style={{ backgroundColor: "transparent", borderColor: "#444", color: "white" }}>{loc.zip}</td>
                                        <td style={{ backgroundColor: "transparent", borderColor: "#444", color: "white" }}>{loc.phone}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </ShellCard>

                <div className="mt-5 text-center rounded shadow-sm py-4">
                    <p className="fw-bold fs-5 text-white mb-0">
                        Call{" "}
                        <a href="tel:188841METRO" className="text-warning">1-888-41-METRO</a>{" "}
                        for more information.
                    </p>
                </div>
            </div>
            <div className="container" style={{ marginBottom: "32px" }}>
                <div className="row text-white">
                    <p>
                        Superb Customer Service
                    </p>
                    <p>
                        At Metro we always aim to provide an exceptional and pain free educational experience. We do this by only offering state approved courses that use cutting edge technology and always providing first rate customer service. Here are some reviews left by past clients!
                    </p>
                </div>
            </div>
        </>
    );
};

export default BureauAdministrativeReview;
